import { legacyBoUserStorageKey, UserLoginData } from '@treasury/domain/services/authentication';

export class BoPagePushService {
    // eslint-disable-next-line no-empty-function
    constructor(private $window: ng.IWindowService) {}

    static $inject = ['$window'];

    private currentUser?: UserLoginData;

    public getUser() {
        if (!this.currentUser) {
            const userJson = this.$window.sessionStorage.getItem(legacyBoUserStorageKey);
            if (!userJson) {
                throw new Error(
                    'Could not get the current user. It was not in memory or previously set in storage.'
                );
            }

            this.currentUser = JSON.parse(userJson);
        }
        return this.currentUser;
    }

    public setUser(user: UserLoginData) {
        if (!user) {
            return;
        }

        const userJson = JSON.stringify(user);
        this.$window.sessionStorage.setItem(legacyBoUserStorageKey, userJson);
        this.currentUser = user;
    }
}

angular.module('backOffice').service('pagePushService', BoPagePushService);
